import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import moment from 'moment';


function Report_Njc_3c() {

     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({eventtype:'all'});
    const [err,setErr]=useState('');
    const [courts, setCourts] = useState([]);
     const [count,setCount] = useState(0);
    const [openOption, setOpenOption] = useState(false);
    const [roles, setRoles] = useState([]);
    const [selectedCases, setSelectedCases] = useState({});
    const [quarters, setQuarters] = useState([]);
          useEffect(() => {
            //  onLoad();    
              onLoadRoles() ;  
              setQuarters(getQuarterArray(2023,0));
        }, []);

 useEffect(() => {
           
  if(search.divisionid>0){
    //load division
    onLoadJudges(search.divisionid);
  }
        }, [search.divisionid]); 

const onSearchChange = (e) => {
    setSearch({...search, [e.target.name]: e.target.value})
}


  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/report/njc-3/${sear.eventtype}/${sear.divisionid}/${sear.judgeid}/${sear.lastdate}`, {
                method: 'GET',
              //  body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
               
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoadCourts= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/case-assigment/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.items)
               if(pageIndex==0){
                setCount(data.totalCount)
               }
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }

const getQuarterArray = (startYear, startMonth) => {
  const now = new Date();
  const quarters = [
    { endMonth: 2, endDay: 31, label: "1ST" },
    { endMonth: 5, endDay: 30, label: "2ND" },
    { endMonth: 8, endDay: 30, label: "3RD" },
    { endMonth: 11, endDay: 31, label: "4TH" },
  ];

  const result = [];

  for (let year = startYear; year <= now.getFullYear(); year++) {
    for (let q = 0; q < quarters.length; q++) {
      const { endMonth, endDay, label } = quarters[q];
      const endDate = new Date(year, endMonth, endDay);

      // Skip if before start date
      if (year === startYear && endMonth < startMonth) continue;

      result.push({
        value: endDate.toISOString().split("T")[0],
        text: `${label} QUARTER ${year}`,
      });

      // Stop once we hit the current quarter
      if (endDate >= now) {
        return result;
      }
    }
  }

  return result;
};

        const onLoadRoles= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/profile/getrolesBySearch/judge`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setRoles(data.roles)
               
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
   
            const onLoadJudges= async()=>{
                //for account registration
                try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/getjudges/${search.divisionid}`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                 setCourts(data.list)
                if(data.code==0){
                    //ready
                    // fee, feelines, cinfo , parties 
                 
                   
                  
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }

  return (
    <div>
     
   <div className='panel'>
          <div className="title"> NJC Report</div>
          <div  className="panel-body">
          <div style={{display:'flex'}}>
          <div className="select-group">
              <label>
                  Event Type  *
              </label>
              <select name="eventtype" value={search.eventtype}  onChange={onSearchChange} required>
                  <option value="all">All </option>
                  <option value="cmc">CMC </option>
                  <option value="trial">Trial </option>
              </select>
          </div>
            <div className="select-group">
                  <label>
                      Division  
                  </label>
                  <select name="divisionid" value={search.divisionid}  onChange={onSearchChange} required>
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.title}
                      </option>
                      ))}
                  </select>
              </div>
        </div>  
<div style={{display:'flex'}}>
                    {/* <div  className="input-group">
                        <label> Select Court Name</label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="person_3" />
                            <input placeholder='First Name' name="firstname" value={search.firstname} onChange={onSearchChange}   />
                        </div>
                    </div> */}
                   <div className="select-group">
                          <label>
                              Judges  
                          </label>
                          <select name="judgeid" value={search.judgeid}  onChange={onSearchChange} >
                              <option value="">Select </option>
                              {courts.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.suffix} {opt.firstName} {opt.lastName??''}
                              </option>
                              ))}
                          </select>
                      </div>
            <div className="select-group">
                          <label>
                              Quarter  
                          </label>
                          <select name="lastdate" value={search.lastdate}  onChange={onSearchChange} required>
                              <option value="">Select </option>
                              {quarters.map((opt,ind) => (
                              <option key={ind} value={opt.value}>
                                  {opt.text}
                              </option>
                              ))}
                          </select>
                      </div>               
        </div>
        

          </div>
            
          <div className='panel-btn'><JisButton onClick={()=>onSearch(search)} >Generate Report</JisButton></div>        

      </div>
      
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases-report">
    
  <span>NJC Report 3</span><span className='total'>Total Records: {count}</span>
  <div className='no-print'><span className='specialaction'><Link to={`/reports/print/njc3/${search.eventtype}/${search.judgeid}/${search.divisionid}/${search.lastdate}`} target='_blank'>Print</Link> </span>  </div>
</div>
      <table className="case-table">
  <thead>
    <tr>
      <th>Cases</th>
      <th>(1)<br/>CASES BROUGHT FORWARD FROM LAST QUARTER</th>
      <th>(2)<br/>CASES ASSIGNED THIS QUARTER</th>
      <th>(3)<br/>TOTAL OF 1 AND 2</th>
      <th>(4)<br/>NO. OF CONTESTED CASES AND JUDGEMENT GIVEN</th>
      <th>(5)<br/>NON CONTESTED AND STRUCK OUT CASES</th>
      <th colSpan={2}>(6)<br/>DECISIONS ON INTERLOCUTORY PROCEEDINGS</th>
      <th>(7)<br/>TOTAL NO OF CASES DISPOSED OF DURING THE QUARTER</th>
      <th>(8)<br/>CASES PENDING AT THE END OF THE QUARTER</th>
    </tr>
    <tr>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th>Contested</th>
        <th>Non-Contested</th>
        <th></th>
        <th></th>
        
    </tr>
  </thead>
  <tbody>
    
     {cases?.map((opt, index) => (
       <tr key={index} >
      <td>{opt.case_Type}</td>
      <td>{opt.previousQuarterScheduled}</td>
       <td>{opt.currentQuarterUnconcluded}</td>
      <td> {opt.totalCount}</td>
      <td>{opt.casesWithMultipleClaimants}</td>
      <td> {opt.casesWithStruckout}</td>
        <td>{opt.interlocContested}</td>
      <td>{opt.interlocNotContested}</td>
       <td>{opt.casesTotalDispose}</td>
      <td>{opt.pendingCases}</td>

    </tr>
    ))} 
    
    <tr style={{fontWeight:'bold'}}>
        <td>Total</td>
        <td>{cases.reduce((sum, item) => sum + item.previousQuarterScheduled, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.currentQuarterUnconcluded, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.totalCount, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesWithMultipleClaimants, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesWithStruckout, 0)}</td>
         <td>{cases.reduce((sum, item) => sum + item.interlocContested, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.interlocNotContested, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesTotalDispose, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.pendingCases, 0)}</td>
    </tr>


  </tbody>
</table>

</div>}
<BackLoader open={loading} />

  
    </div>
  );
}


export default Report_Njc_3c;